/**
 * 配置说明
 * title: 跳转页面自动设置头部标题
 */
export default [
  {
    name: 'MemberIndex',
    path: '/member/index',
    component: () =>
      import(/* webpackChunkName: "MemberIndex" */ '@/views/member/index'),
    meta: { title: '会员中心' },
  },
  {
    name: 'MemberBuySuccess',
    path: '/member/buy-success',
    component: () =>
      import(
        /* webpackChunkName: "MemberBuySuccess" */ '@/views/member/buy-success'
      ),
    meta: { title: ' ', style: 'navigation' },
  },
  {
    name: 'MemberBuyFailure',
    path: '/member/buy-failure',
    component: () =>
      import(
        /* webpackChunkName: "MemberBuyFailure" */ '@/views/member/buy-failure'
      ),
    meta: { title: ' ' },
  },
  {
    name: 'MemberFreeze',
    path: '/member/member-freeze',
    component: () =>
      import(
        /* webpackChunkName: "MemberFreeze" */ '@/views/member/member-freeze'
      ),
    meta: { title: '' },
  },
  {
    name: 'FreezeApplyResult',
    path: '/member/freeze-apply-result',
    component: () =>
      import(
        /* webpackChunkName: "MemberFreezeResult" */ '@/views/member/member-freeze/freeze-apply-result'
      ),
    meta: { title: '' },
  },
  {
    name: 'RightsPk',
    path: '/member/rights-pk',
    component: () =>
      import(
        /* webpackChunkName: "RightsPk" */ '@/views/member/rights-pk'
      ),
    meta: { title: ' ' },
  },
  {
    name: 'BirthdayGift',
    path: '/member/birthday-gift',
    component: () =>
      import(
        /* webpackChunkName: "BirthdayGift" */ '@/views/member/birthday-gift'
      ),
    meta: { title: '生日礼' },
  },
  // 推荐会员
  {
    name: 'MemberRecommend',
    path: '/member/member-recommend',
    component: () =>
      import(
        /* webpackChunkName: "MemberRecommend" */ '@/views/member/member-recommend'
      ),
    meta: { title: ' ' },
  },
  // 自动续费管理
  {
    name: 'AutoRenewManage',
    path: '/member/auto-renew-manage',
    component: () =>
      import(
        /* webpackChunkName: "AutoRenewManage" */ '@/views/member/auto-renew/manage'
      ),
    meta: { title: '自动续费管理' },
  },
  // 共用：自动续费挽留页、关闭成功结果页
  {
    name: 'AutoRenewClose',
    path: '/member/auto-renew-close',
    component: () =>
      import(
        /* webpackChunkName: "AutoRenewClose" */ '@/views/member/auto-renew/close'
      ),
    meta: { title: '' },
  },
  {
    name: 'CommissionIndex',
    path: '/commission/index',
    component: () =>
      import(
        /* webpackChunkName: "CommissionIndex" */ '@/views/member/commission/index'
      ),
    meta: { title: '减佣卡商城' },
  },
  {
    name: 'CommissionBuySuccess',
    path: '/commission/buy-success',
    component: () =>
      import(
        /* webpackChunkName: "CommissionBuySuccess" */ '@/views/member/commission/buy-success'
      ),
    meta: { title: ' ' },
  },
  {
    name: 'CommissionBuyFailure',
    path: '/commission/buy-failure',
    component: () =>
      import(
        /* webpackChunkName: "CommissionBuyFailure" */ '@/views/member/commission/buy-failure'
      ),
    meta: { title: ' ' },
  },
  // 自动续费管理
  {
    name: 'CommissionAutoRenewManage',
    path: '/commission/auto-renew-manage',
    component: () =>
      import(
        /* webpackChunkName: "CommissionAutoRenewManage" */ '@/views/member/commission/auto-renew/manage'
      ),
    meta: { title: '自动续费管理' },
  },
  // 共用：自动续费挽留页、关闭成功结果页
  {
    name: 'CommissionAutoRenewClose',
    path: '/commission/auto-renew-close',
    component: () =>
      import(
        /* webpackChunkName: "CommissionAutoRenewClose" */ '@/views/member/commission/auto-renew/close'
      ),
    meta: { title: '' },
  },
];
